//Match title height


function MatchHeight() {
  
	jQuery(".blog-post-section .featured-blog--grid .article--item--excerpt").matchHeight();
    jQuery(".grid--flush-bottom .grid__item h2.rte--block").matchHeight();
    jQuery(".grid-product__price").matchHeight();
    jQuery(".grid-product .grid-item__meta").matchHeight();
    jQuery(".template-search .grid-item__meta .h4").matchHeight();
    jQuery(".grid__item .rte-setting p").matchHeight();
    jQuery(".grid-article__meta a.article__title").matchHeight();
    jQuery(".logo-bar .logo-bar__item image-element").matchHeight(); 
	jQuery(".logo-bar__item img").matchHeight();
    jQuery(".logo-bar .logo-bar__item .h4").matchHeight();    
  
  
}
MatchHeight();

jQuery(".template-collection .site-nav--has-dropdown").addClass("active");   

jQuery("details").hover(function () {
    jQuery(this).toggleClass("open");
  jQuery('details').attr('open', true);
 });




